import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { onboardingRequest } from "constants/apiUrls";

// Business object structure - matches the exact API payload structure
export interface BusinessPayload {
  name: string;
  address: {
    address1: string;
    address2: string;
    zipCode: string;
    country: string;
    countryShortCode: string;
    state: string;
    stateShortCode: string;
    city: string;
  };
  logo: null | string;
  website: string;
  phoneNumber: string[];
  categories: string[];
  openExternalLinks: Array<{
    metaExternalLinkUuid: string;
    url: string;
  }>;
  businessOpeningHours: Array<{
    day: number; // Numeric day: 1 = Monday, 2 = Tuesday, etc.
    startTime: string;
    endTime: string;
  }>;
  businessHourNotes: string;
  photos?: string[];
}

// Request payload type - wraps business object
export interface OnboardingRequestPayload {
  business: BusinessPayload;
  communityUuid?: string; // Optional community UUID
  referralCode?: string;  // Optional referral code
}

// Response type - flexible to match actual API
export interface OnboardingRequestResponse {
  success?: boolean;
  message?: string;
  data?: any;
  communityUuid?: string;
  communityAddress?: {
    address1?: string;
    state?: string;
    city?: string;
    zipCode?: string;
    stateShortCode?: string;
    countryShortCode?: string;
  };
  business?: {
    name?: string;
    uuid?: string;
    [key: string]: any;
  };
  needsExtraInfromation?: boolean;
  communityExtraInfo?: any[];
  state?: string;
  step?: string;
  user?: any;
  [key: string]: any; // Allow any additional fields
}

const onboardingApi = createApi({
  reducerPath: "onboardingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      headers.set("bludot-app-name", "business-rewards");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    submitOnboardingRequest: builder.mutation<
      OnboardingRequestResponse,
      OnboardingRequestPayload
    >({
      query: (data) => ({
        url: onboardingRequest,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useSubmitOnboardingRequestMutation } = onboardingApi;
export default onboardingApi;
